export const AllStates = [
  { value: "", state: "Select State" },
  { value: "Andhra Pradesh", state: "Andhra Pradesh" },
  {
    value: "Andaman and Nicobar Islands",
    state: "Andaman and Nicobar Islands",
  },
  { value: "Arunachal Pradesh", state: "Arunachal Pradesh" },
  { value: "Assam", state: "Assam" },
  { value: "Bihar", state: "Bihar" },
  { value: "Chandigarh", state: "Chandigarh" },
  { value: "Chhattisgarh", state: "Chhattisgarh" },
  { value: "Dadar and Nagar Haveli", state: "Dadar and Nagar Haveli" },
  { value: "Daman and Diu", state: "Daman and Diu" },
  { value: "Delhi", state: "Delhi" },
  { value: "Lakshadweep", state: "Lakshadweep" },
  { value: "Puducherry", state: "Puducherry" },
  { value: "Goa", state: "Goa" },
  { value: "Gujarat", state: "Gujarat" },
  { value: "Haryana", state: "Haryana" },
  { value: "Himachal Pradesh", state: "Himachal Pradesh" },
  { value: "Jammu and Kashmir", state: "Jammu and Kashmir" },
  { value: "Jharkhand", state: "Jharkhand" },
  { value: "Karnataka", state: "Karnataka" },
  { value: "Kerala", state: "Kerala" },
  { value: "Madhya Pradesh", state: "Madhya Pradesh" },
  { value: "Maharashtra", state: "Maharashtra" },
  { value: "Manipur", state: "Manipur" },
  { value: "Meghalaya", state: "Meghalaya" },
  { value: "Mizoram", state: "Mizoram" },
  { value: "Nagaland", state: "Nagaland" },
  { value: "Odisha", state: "Odisha" },
  { value: "Punjab", state: "Punjab" },
  { value: "Rajasthan", state: "Rajasthan" },
  { value: "Sikkim", state: "Sikkim`" },
  { value: "Tamil Nadu", state: "Tamil Nadu" },
  { value: "Telangana", state: "Telangana" },
  { value: "Tripura", state: "Tripura" },
  { value: "Uttar Pradesh", state: "Uttar Pradesh" },
  { value: "Uttarakhand", state: "Uttarakhand" },
  { value: "West Bengal", state: "West Bengal" },
];

export const Budget = [
  { value: "", data: "Selected Budget Group" },
  { value: "0", data: "Free" },
  { value: "<750", data: "Less than 750" },
  { value: ">750", data: "More than 750" },
  { value: ">1000", data: "More than 1000" },
];

export const EducationalQualifications = [
  { value: "", data: "Select Education Level" },
  { value: "no_formal_education", data: "No Formal Education" },
  { value: "pre_high_school", data: "Pre High School" },
  { value: "high_school", data: "High School" },
  { value: "intermediate", data: "Intermediate" },
  { value: "bachelor", data: "Bachelor" },
  { value: "masters", data: "Masters" },
  { value: "other", data: "Other" },
];

export const RelationshipStatus = [
  { value: "", data: "Select Relationship Status" },
  { value: "single", data: "Single" },
  { value: "married", data: "Married" },
  { value: "divorced", data: "Divorced" },
  { value: "seperated", data: "Seperated" },
  { value: "widowed", data: "Widowed" },
  { value: "other", data: "Other" },
];

export const OccupationType = [
  { value: "", data: "Select If Applicable" },
  { value: "government", data: "Government" },
  { value: "private", data: "Private" },
  { value: "personal", data: "Personal" },
  { value: "other", data: "Other" },
];

export const Issues = [
  { value: "anxiety", label: "Anxiety" },
  { value: "phobias", label: "Phobias" },
  { value: "dissociative_disorder", label: "Dissociative Disorder" },
  { value: "mental_health", label: "Mental Health" },
  { value: "anger_issues", label: "Anger Issues" },
  { value: "Crying spells", label: "Crying Spells" },
  { value: "depressed_mood", label: "Depressed Mood" },
  { value: "grief", label: "Grief" },
  { value: "feeling_low", label: "Feeling Low" },
  { value: "understand_my_issue", label: "Understand my issue" },
  { value: "overwhelming_sadness", label: "Overwhelming Sadness" },
  { value: "unable_to_enjoy_activities", label: "Unable To Enjoy Activities" },
  { value: "decreased_need_for_sleep", label: "Decreased Need For Sleep" },
  { value: "loss_of_interest", label: "Loss of interest" },
  {
    value: "difficulties_in_concentration",
    label: "Difficulties In Concentration",
  },
  { value: "increase_in_appetite", label: "Increase In Appetite" },
  { value: "decrease_in_appetite", label: "Decrease In Appetite" },
  { value: "excessive_guilt", label: "Excessive Guilt" },
  { value: "increased_irritability", label: "Increased Irritability" },
  { value: "racing_thoughts", label: "Racing thoughts" },
  { value: "impulsivity", label: "Impulsivity" },
  { value: "panic _attacks", label: "Panic Attacks" },
  { value: "unexplained_fears", label: "Unexplained Fears" },
  { value: "excessive_worrying", label: "Excessive Worrying" },
  { value: "avoidance", label: "Avoidance" },
  { value: "hallucinations", label: "Hallucinations" },
  { value: "suspiciousness", label: "Suspiciousness" },
  { value: "increased_libido", label: "Increased Libido" },
  { value: "decreased_libido", label: "Decreased Libido" },
  { value: "relationship", label: "Relationship" },
  { value: "breakup", label: "Breakup" },
  { value: "family_issues", label: "Family Issues" },
  { value: "overthinking", label: "Overthinking" },
  { value: "clinical_disorders", label: "Clinical Disorders" },
  { value: "suicidal_ideations", label: "Suicidal Ideations" },
  { value: "loneliness", label: "Loneliness" },
  { value: "procrastination", label: "Procrastination" },
  { value: "increased_need_for_sleep", label: "Increased Need For Sleep" },
  { value: "work_stress", label: "Work Stress" },
  { value: "exam_stress", label: "Exam Stress" },
  { value: "self_esteem", label: "Self Esteem" },
  { value: "trauma", label: "Trauma" },
  { value: "self_harm", label: "Self Harm" },
  { value: "addiction", label: "Addiction" },
  { value: "depression", label: "Depression" },
  { value: "student_career ", label: "  Student Career " },
  { value: "intimacy", label: "Intimacy" },
  { value: "founder_stress", label: "Founder Stress" },
  { value: "ptsd", label: "PTSD" },
  { value: "low_confidence", label: "Low Confidence" },
  { value: "mood_swings", label: "Mood Swings" },
  { value: "low_motivation", label: "Low Motivation" },
  { value: "work_life_balance", label: "Work life balance" },
  { value: "sexual_dysfunction", label: "Sexual Dysfunction" },
];

export const LengthOfConcern = [
  { value: "", data: "Select If Applicable" },
  { value: "<1week", data: "Less Than A Week" },
  { value: "<1month", data: "Less Than A Month" },
  { value: "few_months", data: "Few Months" },
  { value: "1year", data: "Almost A Year" },
  { value: "few_years", data: "Couple Of Years" },
  { value: "long_term", data: "Long Term" },
];

export const SuggestedExperts = [
  { value: "", label: "Select If Applicable" },
  { value: "expert18_avani", label: "Avani" },
  { value: "expert22_ananda", label: "Ananda" },
  { value: "expert_parthg", label: "Parth Gandhi" },
  // { value: "expert36_ankita", label: "Ankita" },
  // { value: "expert26_anoushka", label: "Anoushka" },
  // { value: "expert2_anupama", label: "Anupama" },
  // { value: "expert33_dechen", label: "Dechen" },
  // { value: "expert19_khyati", label: "Khyati" },
  // { value: "expert21_krishna", label: "Krishna" },
  { value: "expert29_khushbua", label: "Khushbu A" },
  // { value: "expert32_kruttikka", label: "Kruttikka" },
  // { value: "expert31_kaynaat", label: "Kaynaat" },
  // { value: "expert44_kashika", label: "Kashika" },
  // { value: "expert25_khushboo", label: "Khushboo" },
  // { value: "expert23_mansoor", label: "Mansoor" },
  // { value: "expert24_mansi", label: "Mansi" },
  // { value: "expert9_mahi", label: "Mahi" },
  // { value: "expert30_munira", label: "Munira" },
  // { value: "expert40_meharmeet", label: "Meharmeet" },
  // { value: "expert43_mehr", label: "Mehr" },
  // { value: "expert35_nidhi", label: "Nidhi" },
  // { value: "expert8_poojita", label: "Poojita" },
  // { value: "expert27_preetha", label: "Preetha" },
  // { value: "expert41_rashi", label: "Rashi" },
  // { value: "expert39_rachel", label: "Rachel" },
  { value: "expert46_risha", label: "Risha" },
  // { value: "expert11_shruti", label: "Shruti" },
  // { value: "expert15_sharmeen", label: "Sharmeen" },
  { value: "expert28_sakina", label: "Sakina" },
  { value: "expert34_shefali", label: "Shefali" },
  // { value: "expert38_sikha", label: "Sikha" },
  // { value: "expert17_sanjoli", label: "Sanjoli" },
  // { value: "expert6_sonam", label: "Sonam" },
  // { value: "expert7_sanchari", label: "Sanchari" },
  // { value: "expert42_supriya", label: "Supriya" },
  { value: "expert45_srimoyee", label: "Srimoyee" },
  // { value: "expert48_sonia", label: "Sonia" },
  // { value: "expert47_tanuushree", label: "Tanuushree" },
  { value: "expert4_tamannarajpal", label: "Tamanna Rajpal" },
  // { value: "expert5_tamannagrewal", label: "Tamanna Grewal" },
  // { value: "expert10_tanya", label: "Tanya" },
  // { value: "expert20_yogita", label: "Yogita" },
  { value: "expert37_yamini", label: "Yamini" },
  { value: "expert1_zoha", label: "Zoha" },
  // { value: "expert51_mudassir", label: "Mudassir M" },
  // { value: "expert52_tanviarneja", label: "Tanvi Arneja" },
  // { value: "expert53_sanjanabarot", label: "Sanjana Barot" },
  // { value: "expert54_gunjanjoshi", label: "Gunjan Joshi" },
  // { value: "expert55_varunpreetsaini", label: "Varun Preet Saini" },
  // { value: "expert58_divyakhanna", label: "Divya Khanna" },
  // { value: "expert59_hansak", label: "Hansa K" },
  // { value: "expert60_anuradhakunte", label: "Anuradha Kunte" },
  { value: "expert61_sharongeorge", label: "Sharon George" },
  { value: "expert62_divyanganay", label: "Divyangana Y" },
  // { value: "expert63_sumerasethi", label: "Sumera Sethi" },
  // { value: "expert64_hiteshkumar", label: "Hitesh Kumar" },
  { value: "expert65_jagrutishah", label: "Jagruti shah" },
  // { value: "expert66_shiwanikohli", label: "Shiwani Kohli" },
  // { value: "expert67_ushaswapnil", label: "Usha Swapnil Gaonkar" },
  // { value: "expert68_jayaiyer", label: "Jaya Iyer" },
  // { value: "expert69_jankiverma", label: "Dr. Janki Verma" },
  // { value: "expert71_harkiratkaur", label: "Harkirat Kaur" },
  // { value: "expert72_pallabibose", label: "Pallabi Bose" },
  { value: "expert73_shwetatayal", label: "Shweta Tayal Goenka" },
  // { value: "expert74_srinidhiesh", label: "Srinidhi Eshwaroju" },
  // { value: "expert75_rashmishah", label: "Rashmi Shah" },
  // { value: "expert76_sriradhapodder", label: "Sriradha Podder" },
  { value: "expert77_pritikasangwan", label: "Pritika Sangwan" },
  // { value: "expert78_anujasathe", label: "Anuja Sathe" },
  // { value: "expert79_dowlathnisha", label: "Dowlath Nisha" },
  { value: "expert80_anuveetkaur", label: "Anuveet Kaur" },
  // { value: "expert81_sumishreya", label: "Sumi Shreya" },
  // { value: "expert82_kazinafisa", label: "Kazi Nafisa Rahman" },
  // // { value: "expert83_suryatapamaity", label: "Suryatapa Maity" },
  // { value: "expert84_fizapreetdhillon", label: "Fizapreet Dhillon" },
  // // { value: "expert85_niharikagargya", label: "Niharika Gargya" },
  // // { value: "expert86_nishasinha", label: "Nisha Sinha" },
  { value: "expert87_siddharthsharma", label: "Siddharth Sharma" },
  // { value: "expert88_keerthanapandian", label: "Keerthana Pandian" },
  { value: "expert89_Supritha", label: "Supritha" },
  // { value: "expert90_simranmalik", label: "Simran Malik" },
  // { value: "expert91_sahersiddiqui", label: "Saher Siddiqui" },
  { value: "expert92_drashtisenghani", label: "Drashti Senghani" },

  // { value: "expert93_tejalikunte", label: "Tejali Kunte" },
  // { value: "expert94_meenal", label: "Meenal" },
  // { value: "expert95_gowthamigarimalla", label: "Gowthami Garimalla" },
  {
    value: "expert96_vasundhrachoudhary",
    label: "Vasundhra Choudhary Clinical",
  },
  { value: "expert97_vasundhrachoudhary", label: "Vasundhra Choudhary Yoga" },
  // { value: "expert98_zarinebharda", label: "Zarine Bharda" },
  // { value: "expert99_charusukheja", label: "Charu Sukheja" },
  // { value: "expert101_rohituttam", label: "Rohit Uttam Malve" },
  // { value: "expert102_mohdumar", label: "Mohd Umar Khan" },
  // { value: "expert100_anushreeg", label: "Anushree Gupta" },
  // { value: "expert103_simranmistry", label: "Simran Mistry" },
  // { value: "expert105_kartikrai", label: "Kartik Rai" },
  // { value: "expert106_nadiaabdul", label: "Nadia Abdul Raheem" },
  { value: "expert107_himanshisharma", label: "Himanshi Sharma" },
  { value: "expert108_sanhatipanigrahi", label: "Sanhati Panigrahi" },
  // { value: "expert109_pragatiAggarwal", label: "Pragati Aggarwal" },
  // { value: "expert110_meenakshibhardwaj", label: "Meenakshii Bhardwwaj" },
  // { value: "expert111_drgeorge", label: "Dr. George Joseph V" },
  // { value: "expert112_jaffrin", label: "Jaffrin" },
  // { value: "expert113_nishi", label: "Nishi" },
  // { value: "expert114_harshitaanand", label: "Harshita Anand" },
  { value: "expert115_sohinisarkar", label: "Sohini Sarkar" },
  { value: "expert116_suhrudhaa", label: "Suhrudhaa" },
  // { value: "expert113_subiksha", label: "Subiksha Raman" },
  { value: "expert_rahul", label: "Rahul Verma" },
  { value: "expert_simardang", label: "Simar Dang" },
  { value: "expert_sana", label: "Sana Panagar" },
  { value: "expert_devashish", label: "Dr. Devashish" },
  { value: "expert_kritivivek", label: "Kriti K Vivek" },
  { value: "expert_hanumanhade", label: "Hanuman Hade" },
  { value: "expert_shreyaharan", label: "Shreya R Haran" },
  { value: "expert_prekshaporwal", label: "Preksha Porwal" },
  { value: "expert_niharikajoshi25", label: "Niharika Joshi" },
  { value: "expert_drneeharika", label: "Dr Neeharika" },
  { value: "expert_nehammodi", label: "Neha M Mody" },
  { value: "expert_nehammodi_couple", label: "Neha M Mody (Couple)" },
  // { value: "expert_devashish", label: "Dr. Devashish" },
  { value: "expert_alia", label: "Alia Vashishth" },
  { value: "expert_alia_couple", label: "Alia Vashishth (Couple)" },
  { value: "expert_kamakshi", label: "Kamakshi Gupte" },
  { value: "expert_ananyas", label: "Ananya Srinivasa" },
  { value: "expert_anushab", label: "Anusha Babbar" },
  { value: "expert_chaitralee", label: "Chaitralee Deshpande" },
  { value: "expert_aditisolomon", label: "Aditi Solomon" },
  { value: "expert_ridhichadha", label: "Ridhi Chadha" },
  { value: "expert_vaishnavi", label: "Vaishnavi" },
  { value: "expert_kamaraj", label: "Kamaraj.M" },
  { value: "expert_tanvib", label: "Tanvi Bhardwaj" },
  { value: "expert_deepikagupta", label: "Deepika Gupta" },
  { value: "expert_seijal", label: "Seijal" },
  { value: "expert_nishi", label: "Nishi" },
  { value: "expert_manya", label: "Manya Kaushik" },
  { value: "expert_mayuriu", label: "Dr. Mayuri Upmanyu" },
  { value: "expert_yashna", label: "Yashna" },
  { value: "expert_samriddhig", label: "Samriddhi Ghatak" },
  { value: "expert_aryak", label: "Arya Kaushik" },
  { value: "expert_tamrina", label: "Tamrina Matta" },
  // { value: "workshop1_art", label: "Art Therapy" },
  // { value: "workshop2_caregiver", label: "Caregiver Therapy" },
  // { value: "workshop3_drama", label: "Drama Therapy" },
  // { value: "workshop4_movement", label: "Movement Therapy" },
  // { value: "workshop5_music", label: "Music Therapy" },
  // { value: "workshop6_mindfulness", label: "Mindfulness Therapy" },
  // { value: "expert0_psychiatry", label: "Psychiatry" },
  // { value: "test_ayush", label: "Ayush Manoshala" },
  // { value: "test_amit", label: "Amit Manoshala" },
];

export const SuggestedTherapyType = [
  { value: "", data: "Select If Applicable" },
  { value: "creative", data: "Creative" },
  { value: "counseling", data: "Counseling" },
  { value: "clinical", data: "Clinical" },
  { value: "psychiatry", data: "Psychiatry" },
];

export const PreferedLanguage = [
  { value: "", label: "No Preference" },
  { value: "hindi", label: "Hindi" },
  { value: "english", label: "English" },
  { value: "bengali", label: "Bengali" },
  { value: "urdu", label: "Urdu" },
  { value: "punjabi", label: "Punjabi" },
  { value: "marathi", label: "Marathi" },
  { value: "telugu", label: "Telugu" },
  { value: "tamil", label: "Tamil" },
  { value: "gujarati", label: "Gujarati" },
  { value: "kannada", label: "Kannada" },
  { value: "odia", label: "Odia" },
  { value: "malayalam", label: "Malayalam" },
  { value: "assamese", label: "Assamese" },
  { value: "other", label: "Other" },
];

export const TherapyDeliveryMode = [
  { value: "", data: "No Preference" },
  { value: "video", data: "Video" },
  { value: "chat", data: "Chat" },
  { value: "call", data: "Call" },
  { value: "inperson", data: "Inperson" },
];

export const TherapistAgeGroup = [
  { value: "", data: "No Preference" },
  { value: "<25", data: "Less Than 25" },
  { value: "<30", data: "Less Than 30" },
  { value: "<35", data: "Less Than 35" },
  { value: "<40", data: "Less Than 40" },
  { value: ">40", data: "More Than 40" },
];

export const GenderOptions = [
  { value: "", data: "No Preference" },
  { value: "male", data: "Male" },
  { value: "female", data: "Female" },
  { value: "other", data: "Other" },
];

export const YesNoOptions = [
  { value: "select", data: "Please Select" },
  { value: "yes", data: "Yes" },
  { value: "no", data: "No" },
];

export const FitnessOptions = [
  { value: "", data: "Select If Applicable" },
  { value: "not_fit", data: "Not Fit At All" },
  { value: "neither", data: "Not Fit Or Unfit" },
  { value: "reasonably_fit", data: "Reasonably Fit" },
  { value: "fit", data: "Fit" },
];

export const TheraputicHistory = [
  { value: "alternative", data: "Alternative" },
  { value: "counseling", data: "Counseling" },
  { value: "clinical", data: "Clinical" },
  { value: "psychiatry", data: "Psychiatry" },
];

export const UrgencyOfIntervention = [
  { value: "", data: "Not Selected" },
  { value: "low", data: "Low" },
  { value: "mid", data: "Mid" },
  { value: "high", data: "High" },
];

// {value:"",data:""}
// {value: "",label: "" },
